<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Master templates</ion-title>
    <ion-button slot="end" fill="clear" (click)="createCollectionTemplate()"><ion-icon name="add-outline"></ion-icon>Add</ion-button>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div sxPadding="medium">
    <ion-list>
      <ion-item
        button=""
        *ngFor="let masterTemplate of masterTemplates"
        (click)="openMasterTemplate(masterTemplate)">
        <ion-label>{{ masterTemplate?.template?.purpose }}</ion-label>
      </ion-item>
    </ion-list>
  </div>

</ion-content>
